import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Gamepad2, Zap } from 'lucide-react';
import './App.css';

const games = [
    {
        id: 'neon-gravity-runner',
        title: 'Neon Gravity Runner',
        tag: 'New',
        desc: 'Flip gravity. Dodge obstacles. Collect gems. How long can you survive in this neon-lit endless runner?',
        controls: 'Space / Click / Tap',
        color: '#00ccff',
        gradient: 'linear-gradient(135deg, #0a2a4a 0%, #0f1a3a 50%, #1a0a3a 100%)',
        borderColor: 'rgba(0, 204, 255, 0.3)',
        link: '/games/neon-gravity-runner'
    },
    // Future games go here
];

function GamesHub() {
    const navigate = useNavigate();

    return (
        <div className="games-hub">
            <div className="games-hub-inner">
                <button className="games-back-btn" onClick={() => navigate('/')}>
                    <ArrowLeft size={18} /> Back to Portfolio
                </button>

                <div className="games-hub-header">
                    <Gamepad2 className="games-hub-icon" />
                    <h1>Arcade</h1>
                    <p className="games-hub-subtitle">Little games I built for fun. Pull up a chair and play.</p>
                </div>

                <div className="games-grid">
                    {games.map((game) => (
                        <div
                            key={game.id}
                            className="game-card"
                            onClick={() => navigate(game.link)}
                            style={{
                                background: game.gradient,
                                borderColor: game.borderColor
                            }}
                        >
                            {game.tag && <span className="game-tag" style={{ color: game.color, borderColor: game.color }}>{game.tag}</span>}
                            <Zap className="game-card-icon" style={{ color: game.color }} />
                            <h3>{game.title}</h3>
                            <p>{game.desc}</p>
                            <div className="game-card-footer">
                                <span className="game-controls-label">Controls: {game.controls}</span>
                                <span className="game-play-btn" style={{ color: game.color, borderColor: game.color }}>Play →</span>
                            </div>
                        </div>
                    ))}

                    {/* Placeholder for future games */}
                    <div className="game-card game-card-coming-soon">
                        <h3>More Coming Soon</h3>
                        <p>I'm always building new things. Check back later for more games.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GamesHub;
